<template>
  <div v-loading="loading" class="pickup-info">
    <avue-detail :option="option" v-model="pickupData">
      <template slot='looseOrderStatusView'>
        {{ (pickupData && looseOrderStatusMap[pickupData.looseOrderStatus]) || '--' }}
      </template>
      <template slot='orderPayStatusView'>
        {{ (pickupData && orderPayStatusMap[pickupData.orderPayStatus]) || '--' }}
      </template>
      <template slot='totalFreightView'>
        {{ getTotalFreight(pickupData) }}
      </template>
      <template slot="pickupTimeView">
        <span>{{ getPickTime(pickupData) }}</span>
        <el-button
          type="text"
          size="small"
          style="margin-left: 10px"
          @click="showDialog"
        >
          查看修改记录
        </el-button>
      </template>
      <template slot='courierInfoView'>
        {{ getCourierInfo(pickupData) }}
      </template>
      <template slot='retentionFlagView'>
        {{ (pickupData && retentionFlagMap[pickupData.retentionFlag]) || '--' }}
      </template>
    </avue-detail>

    <div class="pickup-info-footer">
      <el-button v-if="waybillNo" type="text" class="refresh-btn" @click="refresh">
        <i class="el-icon-refresh"></i>
        刷新
      </el-button>
      <!-- 取消订单按钮 暂时先不上线-->
      <!-- <el-button
        v-if="showCancelBtn"
        type="text"
        class="cancel-btn"
        @click="showCancelDialog"
      >
        <i class="el-icon-circle-close"></i>
        取消订单
      </el-button> -->
    </div>

    <!-- 预约取件记录弹窗 -->
    <el-dialog
      width="900px"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <template slot="title">
        <span class="dialog-title">预约取件记录</span>
      </template>
      <el-table :data="pickupData.tabOrderConventionDesc || []" border>
        <el-table-column prop="operatorType" label="操作" min-width="80" />
        <el-table-column prop="staffInfo" label="操作人" min-width="100" />
        <el-table-column label="预约取件时间" min-width="220">
          <template slot-scope="scope">
            {{ scope.row.conventionStartTime }} 至 {{ scope.row.conventionEndTime }}
          </template>
        </el-table-column>
        <el-table-column prop="conventionTime" label="操作时间" min-width="160" />
      </el-table>
    </el-dialog>

    <!-- 取消订单弹窗 -->
    <el-dialog
      width="600px"
      :visible.sync="cancelDialogVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      @close="resetCancelForm"
    >
      <template slot="title">
        <span class="dialog-title">取消订单</span>
      </template>
      <avue-form
        ref="cancelForm"
        :option="cancelOption"
        v-model="cancelForm"
        :loading="cancelLoading"
        @cancel="handleCancel"
        @submit="handleSubmit"
      >
        <template slot="attachments">
          <div class="upload-tip">（格式要求: JPG, PNG，最多3张，每个文件大小不超过15MB）</div>
          <batch-compress-upload
            ref="batchUpload"
            :limit="3"
            :fileSize="15"
            :multiple="true"
            :fileTypeList="['jpg', 'jpeg', 'png']"
            @uploadSuccess="handleUploadSuccess"
            @uploadRemove="handleUploadRemove"
          />
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import { detailView } from '../pool.js'
import { RESPONSE_CODE } from '@public/http/config'
import BatchCompressUpload from '@/components/BatchCompressUpload.vue';

export default {
  name: 'PickupInfo',

  components: {
    BatchCompressUpload
  },

  props: {
    waybillNo: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'waybillNo' // 'waybillNo' 或 'orderNo'
    },
    visible: {
      type: Boolean,
      default: false
    },
    // 是否显示取消订单按钮
    showCancelBtn: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      pickupData: {},
      loading: false,
      dialogVisible: false,
      // 取消订单弹窗
      cancelDialogVisible: false,
      cancelLoading: false,
      cancelForm: {
        cancelReason: 'AGREEMENT_WITH_CONSUMER',
        attachments: [],
        remarks: ''
      },
      // 取消原因枚举
      cancelReasonOptions: [
        { value: 'AGREEMENT_WITH_CONSUMER', label: '消费者不寄了' }
      ],
      looseOrderStatusMap: {
        203: '待取件',
        206: '待核价',
        207: '待揽收',
        103: '已揽收',
        104: '已取消',
        105: '取件失败'
      },
      orderPayStatusMap: {
        0: '支付成功',
        2: '未支付',
        3: '已关闭',
        6: '支付失败'
      },
      retentionFlagMap: {
        0: '否',
        1: '是'
      },
      imageList: []
    }
  },

  computed: {
    user() {
      return this.$store.state.base.user
    },
    option() {
      return {
        border: false,
        group: [
          {
            column: [
              {
                label: '取件状态',
                prop: 'looseOrderStatus',
                viewslot: true
              },
              {
                label: '支付状态',
                prop: 'orderPayStatus',
                viewslot: true
              },
              {
                label: '运费',
                prop: 'totalFreight',
                viewslot: true
              },
              {
                label: '下单时间',
                prop: 'inputTime'
              },
              {
                label: '预约取件时间',
                prop: 'pickupTime',
                span: 2,
                viewslot: true
              },
              {
                label: '指派小件员信息',
                prop: 'courierInfo',
                viewslot: true
              },
              {
                label: '滞留标识',
                prop: 'retentionFlag',
                viewslot: true
              }
            ]
          }
        ]
      }
    },
    // 取消订单弹窗配置
    cancelOption() {
      return {
        column: [
          {
            label: '取消原因',
            prop: 'cancelReason',
            type: 'select',
            dicData: this.cancelReasonOptions,
            disabled: true,
            span: 2
          },
          {
            label: '附件',
            prop: 'attachments',
            formslot: true,
            viewslot: true,
            span: 2,
            rules: [{ required: true, message: '请上传附件', trigger: ['change', 'blur'] }]
          },
          {
            label: '备注',
            prop: 'remarks',
            type: 'textarea',
            maxlength: 50,
            showWordLimit: true,
            minRows: 3,
            placeholder: '请输入备注（非必填）',
            span: 2
          }
        ]
      }
    }
  },

  watch: {
    // 面板展开时调用接口
    visible: {
      handler(val) {
        if (val) {
          this.fetchPickupInfo()
        }
      },
      immediate: true
    },
    // waybillNo 变化且面板展开时重新调用接口
    waybillNo(val) {
      // 运单号订单号改变，清空数据
      this.pickupData = {}
      if (val && this.visible) {
        this.fetchPickupInfo()
      }
    },
    // inputType 变化且面板展开时重新调用接口
    inputType(val, oldVal) {
      if (val !== oldVal && this.waybillNo && this.visible) {
        if (val === 'orderNo' && /^([0-9]{18,19})$/.test(val)) {
          this.fetchPickupInfo()
        }
        if (val === 'waybillNo' && /^([JU]T)\d{13}$|^\d{13}$/.test(val)) {
          this.fetchPickupInfo()
        }
      }
    }
  },

  methods: {
    async fetchPickupInfo() {
      const params = {}
      if (!this.waybillNo) {
        this.loading = false
        return
      }
      // 根据 inputType 决定使用 waybillNo 还是 orderNo 参数
      if (this.inputType === 'orderNo') {
        params.orderNo = this.waybillNo
      } else {
        params.waybillNo = this.waybillNo
      }

      this.loading = true
      try {
        const res = await detailView.getPickupReservation(params)
        if (res.code === RESPONSE_CODE.SUCCESS) {
          this.pickupData = res.data || {}
          // 触发事件传递取件状态
          this.$emit('looseOrderStatus', this.pickupData.looseOrderStatus || '')
        } else {
          this.pickupData = {}
          this.$emit('looseOrderStatus', '')
        }
      } catch (error) {
        console.log('error', error);
        this.$emit('looseOrderStatus', '')
      } finally {
        this.loading = false
      }
    },

    refresh() {
      this.fetchPickupInfo()
    },

    showDialog() {
      this.dialogVisible = true
    },

    getPickTime(pickupData) {
      const { bestPickTimeStart, bestPickTimeEnd } = pickupData || {}
      return `${bestPickTimeStart || '--'} 至 ${bestPickTimeEnd || '--'}`
    },

    getTotalFreight(pickupData) {
      const { totalFreight } = pickupData || {}
      if (!totalFreight && totalFreight !== 0) {
        return '--'
      } else {
        return `${totalFreight}元`
      }
    },

    getCourierInfo(pickupData) {
      const { pickStaffName, pickStaffMobile } = pickupData || {}
      if (!pickStaffName && !pickStaffMobile) return '--'
      else return `${pickStaffName || ''} ${pickStaffMobile || ''}`
    },

    // 显示取消订单弹窗
    showCancelDialog() {
      this.cancelDialogVisible = true
      // 重置表单
      this.cancelForm = {
        cancelReason: 'AGREEMENT_WITH_CONSUMER',
        attachments: [],
        remarks: ''
      }
    },

    // 关闭取消订单弹窗
    handleCloseCancelDialog() {
      this.$confirm('确认关闭弹窗吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cancelDialogVisible = false
        // 重置表单
        this.cancelForm = {
          cancelReason: 'AGREEMENT_WITH_CONSUMER',
          attachments: [],
          remarks: ''
        }
      }).catch(() => {})
    },

    // 上传成功回调
    handleUploadSuccess(fileList) {
      this.cancelForm.attachments = fileList.map(item => {
        let size = item.size / 1024 / 1024
        // 如果大于0且小于1，设为1
        if (size > 0 && size < 1) {
          size = 1
        }
        return {
          name: item.name,
          url: item.path,
          size: size,
          type: item.contentType
        }
      })
      // 触发附件字段校验
      this.$refs.cancelForm.validateField('attachments')
    },

    // 删除上传文件回调
    handleUploadRemove(fileList) {
      this.cancelForm.attachments = fileList.map(item => {
        let size = item.size / 1024 / 1024
        // 如果大于0且小于1，设为1
        if (size > 0 && size < 1) {
          size = 1
        }
        return {
          name: item.name,
          url: item.path,
          size: size,
          type: item.contentType
        }
      })
      // 触发附件字段校验
      this.$refs.cancelForm.validateField('attachments')
    },
    // 重置取消订单表单
    resetCancelForm() {
      // 清空表单数据
      this.cancelForm = {
        cancelReason: 'AGREEMENT_WITH_CONSUMER',
        attachments: [],
        remarks: ''
      }
      // 重置上传组件
      this.$refs.batchUpload && this.$refs.batchUpload.reset()
    },
    handleCancel() {
      // 关闭弹窗
      this.cancelDialogVisible = false
      // 重置表单
      this.resetCancelForm()
    },

    // 确认取消订单
    async handleSubmit() {
      if (!this.waybillNo) {
        this.$message.error('运单号不能为空')
        return
      }

      this.cancelLoading = true
      try {
        const params = {
          waybillNo: this.waybillNo,
          attachments: this.cancelForm.attachments,
          remarks: this.cancelForm.remarks,
          operatorPhone: this.user.phone
        }

        const res = await detailView.cancelPickupReservation(params)

        if (res.code === RESPONSE_CODE.SUCCESS) {
          this.$message.success('取消订单成功')
          this.cancelDialogVisible = false
          // 重置表单
          this.resetCancelForm()
          // 调用刷新函数
          this.refresh()
        }
      } catch (error) {
        console.error('取消订单失败:', error)
      } finally {
        this.cancelLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">

.pickup-info-footer {
  text-align: right;
}

.refresh-btn {
  color: #e60012;
  font-size: 14px;
  padding-right: 20px;
}

.refresh-btn:hover {
  color: #ff1a1a;
}

// 取消订单按钮样式
.cancel-btn {
  color: #e60012;
  font-size: 14px;
  padding-right: 50px;
}

.cancel-btn:hover {
  color: #ff1a1a;
}

.dialog-title {
  position: relative;
  padding-left: 10px;
  color: #111 !important;
}

.dialog-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  background-color: #e60012;
}

::v-deep .avue-group {
  border: 0 !important;
}
::v-deep .avue-detail__item-- {
  width: 190px !important;
}
::v-deep .avue-detail__item--2 {
  width: 400px !important;
}

// 取消订单弹窗样式
.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.dialog-footer {
  text-align: right;
}
</style>
